import styled from "styled-components";
import * as base from "../../styles/base";

export const Event = styled.div.attrs({
  className: "event-wrapper"
})``;
export const EventDetailsContainer = styled.div.attrs({
  className: "event-wrapper"
})`
  margin: 79px auto 0;
  width: 87.5%;
  max-width: 570px;
`;
export const EventTitle = base.Title.extend`
  font-family: ${base.custom_font_family};
  font-weight: normal;
  font-size: 20px;
  line-height: 1.3;
  text-align: center;
  margin: 20px auto 19px;
  display: flex;
  justify-content: flex-start;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  @media only screen and (min-width:768px) {
    line-height: 1.31;
    justify-content: center;
    font-size: 26px;
    margin-top: 80px;
  }
`;
export const EventDescription = base.Text.extend`
  font-family: ${base.custom_font_family};
  font-weight: normal;
  line-height: 1.5;
  margin-bottom: 20px;
  text-align: left;
  font-style: normal;
  font-stretch: normal;
  font-size: 14px;
  letter-spacing: 0.5px;
  @media only screen and (min-width:768px) {
    text-align: center;
    font-size: 20px;
    line-height: 1.3;
    margin-bottom: 40px;
    letter-spacing: 1px;
  }
`;
export const EventAddress = base.Text.extend`
  font-size: 16px;
  line-height: 1.31;
  margin-bottom: 10px;
  text-align: left;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.6px;
  @media only screen and (min-width:768px) {
    text-align: center;
    font-size: 26px;
    margin-bottom: 20px;
    letter-spacing: 1px;
  }
`;
export const EventDate = base.Text.extend`
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  padding-bottom: 53px;
  line-height: 1.7;
  margin-bottom: 64px;
  border-bottom: 1px solid white;
  text-align: left;
  letter-spacing: 0.6px;
  @media only screen and (min-width:768px) {
    text-align: center;
    font-size: 26px;
    margin-bottom: 75px;
    padding-bottom: 97px;
    letter-spacing: 1px;
    line-height: 1.4;
  }
`;
export const EventVideo = styled.div`
  display: block;
  position: relative;
  width: 100%;
  video {
    display: block;
    width: 100%;
  }
`;
export const EventVideoLogo = styled.img`
  display: block;
  width: 38.4%;
  max-width: 204px;
  
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;



// WEBPACK FOOTER //
// ./src/components/event_details/styled_event_details.js